import Tabs from "@bmi-digital/components/tabs";
import Typography from "@bmi-digital/components/typography";
import { styled } from "@mui/material/styles";
import { LeadBlock } from "@bmi-digital/components";
import CheckIcon from "@bmi-digital/components/icon/Check";
import Accordion, { accordionClasses } from "@bmi-digital/components/accordion";
import AssetsIframe from "../AssetsIframe";

const PREFIX = "ProductLeadBlockStyles";

export const classes = {
  "inline-link": `${PREFIX}-inline-link`,
  "with-paddings": `${PREFIX}-with-paddings`
};

export const StyledDesktopProductLeadBlock = styled("div")(({ theme }) => ({
  ":global": {
    "[class*='MuiBox-root']": {
      padding: "0px"
    }
  },
  [`.${classes["inline-link"]}`]: {
    paddingTop: "10px",
    color: "#0072b0",
    "&:hover": {
      color: "#005b8c"
    },
    transition: "color ease-out 0.25s"
  },

  [theme.breakpoints.down("lg")]: {
    display: "none"
  }
}));

export const StyledProductDescription = styled(Typography)({
  "& > *:first-of-type": {
    marginTop: "0"
  }
});

export const StyledImagesContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "18px",

  [theme.breakpoints.down("md")]: {
    gap: "24px"
  }
}));

export const StyledBlueCheckIcon = styled(CheckIcon)(({ theme }) => ({
  color: theme.colours.accent300
}));

export const StyledImage = styled("img")(({ theme }) => ({
  height: "100px",
  [theme.breakpoints.down("lg")]: {
    height: "80px"
  }
}));

export const StyledDocumentSpan = styled("span")({
  paddingTop: "10px",
  paddingRight: "10px",
  display: "inline-block"
});

export const StyledTabPanel = styled(Tabs.TabPanel)({
  "&&": {
    padding: "30px 0 0 0"
  }
});

export const StyledProductLeadBlockTitle = styled(Typography)({
  marginBottom: "24px"
});

export const StyledProductLeadTabIFrame = styled(AssetsIframe)(({ theme }) => ({
  height: "600px",
  [theme.breakpoints.up("lg")]: {
    height: "800px"
  }
}));

export const StyledLeadBlockContent = styled(LeadBlock.Content)({
  padding: 0
});

export const StyledLeadBlockCard = styled(LeadBlock.Card)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up("lg")]: {
    padding: "0 0 0 24px"
  }
}));

export const StyledTechSpecsLeadBlockCard = styled(StyledLeadBlockCard)(
  ({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      paddingTop: "16px"
    }
  })
);

export const StyledLeadBlock = styled(LeadBlock)({
  margin: 0,
  padding: 0
});

export const StyledDocumentsWrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    paddingBottom: "24px"
  }
}));

export const StyledAccordionItem = styled(Accordion.Item)(({ theme }) => ({
  "&&": {
    borderRadius: "0",
    borderRight: 0,
    borderLeft: 0,
    backgroundColor: theme.colours.white
  },

  "&:last-of-type": {
    boxShadow: "none"
  }
}));

export const StyledAccordionDetails = styled(Accordion.Details)({
  paddingTop: 0,
  paddingBottom: 0,
  borderTop: 0,
  [`&.${classes["with-paddings"]}`]: {
    paddingTop: "12px",
    paddingBottom: "24px"
  }
});

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    display: "none"
  }
}));

export const StyledAccordionSummary = styled(Accordion.Summary)(
  ({ theme }) => ({
    [`&.${accordionClasses.summaryRoot}`]: {
      [`& .${accordionClasses.summaryContent}`]: {
        paddingTop: "15px",
        paddingBottom: "15px",
        marginTop: 0,
        marginBottom: 0
      },

      [theme.breakpoints.down("lg")]: {
        fontSize: "1.25rem",
        lineHeight: "1.2",

        "&:nth-of-type(1)": {
          minHeight: "72px"
        }
      }
    }
  })
);
